<template>
  <div id="footer-bar" :class="[`footer-bar footer-bar-detached`]">
    <button class="footer-bar-link" @click="$emit('on-use-animation', 1)"><receopt-icon
        :class="[isShowPage === 'categories' ? 'active-icon' : '']" /><span>{{
        $t('bottomMenu.category')}}</span></button>
    <button class="footer-bar-link" @click="$emit('on-use-animation', 2)"><graph-icon
        :class="[isShowPage === 'analitycs' ? 'active-icon' : '']" /><span>{{
        $t('bottomMenu.analytic') }}</span></button>
    <button class="circle-nav-2 footer-bar-link" @click="$emit('on-use-animation', 3)"><home-icon /><span
        :class="[isShowPage === 'home' ? 'active-icon' : '']">{{
        $t('bottomMenu.home')}}</span></button>
    <button class="footer-bar-link" @click="$emit('on-use-animation', 4)"><gift-icon width="19px"
        :class="[isShowPage === 'gifts' ? 'active-icon' : '']" /><span>{{
        $t('bottomMenu.gifts')}}</span></button>
    <button class="footer-bar-link" @click="$emit('on-open-menu', 6)"><dots-icons /><span>{{
        $t('bottomMenu.more')}}</span></button>
  </div>
</template>

<script>

// import WalletIcon from "../icons/WalletIcon.vue"
import GraphIcon from "../icons/GraphIcon.vue"
import HomeIcon from "../icons/HomeIcon.vue"
import ReceoptIcon from "../icons/ReceoptIcon.vue"
import DotsIcons from "../icons/DotsIcons.vue"
import { GiftIcon } from 'vue-feather-icons';

export default {
    name: "Bottom-menu-block",
    components: {
            // WalletIcon,
            GraphIcon,
            HomeIcon,
            ReceoptIcon,
            DotsIcons,
            GiftIcon
    },
    props: {
        isShowPage: {
            type: String,
            require: true
        }
    },
    data() {
        return {
        }
    },
    async mounted() {

    },

    methods: {

    },
    computed: {

    },
    watch: {
      isShowPage(newVal, oldVal) {
        let val = oldVal
        val
        console.log({ newVal })
      }
    }
}
</script>

<style scoped>
.footer-bar:not(.iosTabBar) {
    bottom: 15px !important;
}

.footer-bar {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 98;
    backdrop-filter: saturate(180%) blur(10px);
    -webkit-backdrop-filter: saturate(180%) blur(10px);
    background: rgba(255, 255, 255, 0.55);
    box-shadow: 0 -5px 5px 0 rgba(0, 0, 0, 0.04);
    height: 65px;
    display: flex;
    text-align: center;
    transition: all .25s ease;
}

.active-icon {
  color: var(--secondary-bg-color)
}

.active-icon + span {
  color: var(--secondary-bg-color)
}

.footer-bar-detached {
    border-radius: 25px;
    left: 7px !important;
    right: 7px !important;
    bottom: 15px !important;
    box-shadow: 0 0px 15px 0 rgba(0, 0, 0, 0.1) !important;
}

  .footer-bar-link {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: none;
      background: transparent;
      cursor: pointer;
      width: 20%;
    }

.theme-light .footer-bar .footer-bar-link {
    color: #1f1f1f;
}
.footer-bar .footer-bar-link:not(.btn) {
    padding-top: 12px;
    position: relative;
    flex: 1 1 auto;
    color: #1f1f1f;
}
.footer-bar .circle-nav-1::after,
.footer-bar .circle-nav-2::before,
.footer-bar .circle-nav-2::after {
  background-image: var(--main-bg-color) !important;
}



.theme-dark .footer-bar .circle-nav-2::before,
.theme-dark .shadow-bg:after {
  opacity: 0.5 !important;
}

.footer-bar .circle-nav-2 svg {
  color: #FFF !important;
  transform: translateY(-23px);
  font-size: 20px !important;
}

.footer-bar .circle-nav-2::after {
  position: absolute;
  content: "";
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -25px;
  border-radius: 20px;
  z-index: -1;
}

.footer-bar .circle-nav-2::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  margin-top: -25px;
  margin-left: -5px;
  border-radius: 20px;
  background: inherit;
  z-index: -1;
  transform: scale(0.75) translate(-55%, -45%);
  filter: blur(8px);
}

.theme-dark .footer-bar {
  background-color: rgba(0, 0, 0, 0.55);
}

 
 .theme-dark .footer-bar .footer-bar-link {
    color: #FFF;
}

</style>